import { render, staticRenderFns } from "./TotalPostsSharesAndCommentsInTime.vue?vue&type=template&id=735f3d33&"
import script from "./TotalPostsSharesAndCommentsInTime.vue?vue&type=script&lang=js&"
export * from "./TotalPostsSharesAndCommentsInTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports